// Portico Systems Product Data - Modular Index
// Auto-generated from products.js refactor

import { productsLuxuryVinyl } from "./productsLuxuryVinyl";
import { productsCustomLogoMats } from "./productsCustomLogoMats";
import { productsCarpetTile } from "./productsCarpetTile";
import { productsGridEntry } from "./productsGridEntry";
import { productsBroadloom } from "./productsBroadloom";
import { productsCommercialMats } from "./productsCommercialMats";
import { productsNonSlip } from "./productsNonSlip";
import { productsRubberFlooring } from "./productsRubberFlooring";
import { productsAntiFatigue } from "./productsAntiFatigue";
import { productsAccessories } from "./productsAccessories";

// Combined products array (preserves original order)
export const products = [
  ...productsLuxuryVinyl,
  ...productsCustomLogoMats,
  ...productsCarpetTile,
  ...productsGridEntry,
  ...productsBroadloom,
  ...productsCommercialMats,
  ...productsNonSlip,
  ...productsRubberFlooring,
  ...productsAntiFatigue,
  ...productsAccessories,
];

export const allProducts = [...products];


// Product categories - updated counts based on actual products (67 total)
export const categories = [
  { id: "broadloom", name: "Broadloom Rolls & Sheets", count: 9 },
  { id: "carpet-tile", name: "Carpet Tile", count: 15 },
  { id: "custom-logo-mats", name: "Custom Logo Mats", count: 10 },
  { id: "luxury-vinyl", name: "Luxury Vinyl Plank & Tile", count: 4 },
  { id: "grid-entry-systems", name: "Grid Entry Systems", count: 10 },
  { id: "commercial-mats", name: "Commercial Mats", count: 4 },
  { id: "industrial-anti-fatigue", name: "Industrial & Anti-Fatigue Mats", count: 9 },
  { id: "non-slip-flooring", name: "Non-Slip Flooring", count: 1 },
  { id: "recycle-rubber", name: "Recycle Rubber Flooring", count: 5 },
  { id: "accessories", name: "Accessories", count: 20 }
];

// Color tones filter with swatch colors
export const colorTones = [
  { id: "neutral", name: "Neutral", color: "#D4D0C8" },
  { id: "grey", name: "Grey", color: "#808080" },
  { id: "blue", name: "Blue", color: "#4A6FA5" },
  { id: "brown", name: "Brown", color: "#8B4513" },
  { id: "beige", name: "Beige", color: "#D2B48C" },
  { id: "black", name: "Black", color: "#2C2C2C" },
  { id: "multi-color", name: "Multi-Color", gradient: "linear-gradient(135deg, #FF6B6B 0%, #4ECDC4 50%, #FFE66D 100%)" },
  { id: "earth-tones", name: "Earth Tones", gradient: "linear-gradient(135deg, #8B7355 0%, #556B2F 50%, #CD853F 100%)" },
  { id: "green", name: "Green", color: "#4A7C59" },
  { id: "red", name: "Red", color: "#8B3A3A" },
  { id: "tan", name: "Tan", color: "#C4A76C" },
  { id: "charcoal", name: "Charcoal", color: "#36454F" }
];

// Pattern types with icons
export const patternTypes = [
  { id: "berber", name: "Berber", icon: "/Assets/icons/patterns/berber.png" },
  { id: "textured", name: "Textured", icon: "/Assets/icons/patterns/textured.png" },
  { id: "ribbed", name: "Ribbed", icon: "/Assets/icons/patterns/ribbed.png" },
  { id: "modern", name: "Modern", icon: "/Assets/icons/patterns/modern.png" },
  { id: "solid", name: "Solid/Smooth", icon: "/Assets/icons/patterns/solid-smooth.png" },
  { id: "wood-look", name: "Wood Look", icon: "/Assets/icons/patterns/wood-look.png" },
  { id: "stone-look", name: "Stone Look", icon: "/Assets/icons/patterns/stone-look.png" }
];

// Budget levels
export const budgetLevels = [
  { id: "economy", label: "Economy", range: "$" },
  { id: "mid-range", label: "Mid-Range", range: "$$" },
  { id: "premium", label: "Premium", range: "$$$" }
];

// Industries for filtering
export const industries = [
  "Corporate Offices",
  "Fitness Centers & Gymnasiums",
  "Grocery & Convenience Stores",
  "Retailers",
  "Hospitality Sector",
  "Mass Merchandiser",
  "Educational Institutions",
  "Financial Institutions",
  "Government",
  "Pharmacy & Drugstore",
  "Specialty Stores"
];
